export const JIGSAW_PACK_PRODUCT_KEY = "jigsaw_pack";

export const DEFAULT_PACK_PRICE = "$1.99";

export const JIGSAW_PACK_OFFERS = [
    { id: "funny.1", title: "Funny", tier: "t1", price: "$0.99" },
    { id: "animals.1", title: "Animals 1", tier: "t2", price: "$1.99" },
    { id: "animals.2", title: "Animals 2", tier: "t2", price: "$1.99" },
    { id: "flowers.1", title: "Flowers", tier: "t2", price: "$1.99" },
    { id: "ocean.1", title: "Ocean", tier: "t2", price: "$1.99" },
    { id: "food.1", title: "Food", tier: "t2", price: "$1.99" },
    { id: "autumn.1", title: "Autumn", tier: "t2", price: "$1.99" },
    { id: "cities.1", title: "Cities", tier: "t2", price: "$1.99" },
    { id: "travel.1", title: "Travel", tier: "t2", price: "$1.99" },
];

export function jigsawPackPriceKey(tier) {
    if (tier === "free") return null;
    return tier === "t1" ? "jp_t1" : "jp_t2";
}

export function jigsawPackCheckoutPlan(offer) {
    const tier = offer?.tier === "free" || offer?.tier === "t1" ? offer.tier : "t2";
    return {
        name: offer.title,
        price: tier === "free" ? "Free" : tier === "t1" ? "$0.99" : DEFAULT_PACK_PRICE,
        productKey: JIGSAW_PACK_PRODUCT_KEY,
        priceKey: jigsawPackPriceKey(tier),
        packId: offer.id,
        successPath: "/puzzles/jigsaw/packs",
    };
}
